import React, { useEffect, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import "./components.css";
import { getLocalizedFieldLabel } from "../helpers/helpers";
export default function PercentageComponent(props) {
  const { questionKey, value, onChange, label, lang } = props;

  const [inputValue, setInputValue] = useState(
    value === null || value === undefined ? "" : String(value)
  );

  useEffect(() => {
    const next = value === null || value === undefined ? "" : String(value);
    setInputValue(next);
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      setInputValue("");
      onChange(questionKey, "");
      return;
    }

    const normalized = String(raw).replace(",", ".");
    if (!/^[0-9.]*$/.test(normalized)) return;
    const dotMatches = normalized.match(/\./g);
    if (dotMatches && dotMatches.length > 1) return;

    const [intPartRaw, decPartRaw] = normalized.split(".");
    const intPart = intPartRaw || "";
    const decPart = decPartRaw || "";
    if (decPart.length > 7) return;

    if (intPart) {
      const intValue = parseInt(intPart, 10);
      if (!Number.isNaN(intValue) && intValue > 100) return;
    }

    const parsed = parseFloat(normalized);
    if (!Number.isNaN(parsed) && (parsed < 0 || parsed > 100)) return;

    setInputValue(raw);
    onChange(questionKey, normalized);
  };

  const handleBlur = () => {
    if (inputValue === "" || inputValue === null || inputValue === undefined) return;

    const normalized = String(inputValue).replace(",", ".");
    const parsed = parseFloat(normalized);
    if (Number.isNaN(parsed)) {
      onChange(questionKey, "");
      setInputValue("");
      return;
    }

    const clamped = Math.min(100, Math.max(0, parsed));
    const rounded = Number(clamped.toFixed(7));
    onChange(questionKey, rounded);
    setInputValue(String(rounded));
  };

  return (
    <div className="flexAlignColumnClassName">
      <TextField
      label={getLocalizedFieldLabel(questionKey, lang) || label}
        autoComplete="off"
        type="text"
        id={`outlined-number-${questionKey}`}
        className="numberFieldInputComponent"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        inputProps={{
          inputMode: "decimal",
          pattern: "[0-9]*[.,]?[0-9]{0,7}",
        }}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
          classes: {
            root: "outlinedInputRoot",
            focused: "outlinedInputFocused",
            notchedOutline: "outlinedInput",
          },
        }}
        InputLabelProps={{
          classes: {
            root: "outlinedInputLabel",
            focused: "focusedInputLabel"
          }
        }}
      />
    </div>
  );
}
